const mobileViewport = window.matchMedia('(max-width: 749px)');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const MEDIA_SELECTOR = '.product-information__media';
const BUY_SELECTOR = '[data-wc-mobile-buy]';
const CART_DRAWER_SELECTOR = 'cart-drawer-component';
const LOOK_HEADING_SELECTOR = '[data-wc-recommendations-heading]';
const LOOK_GRID_SELECTOR = '[data-wc-complete-the-look-grid]';
const LOOK_SECTION_SELECTOR = 'product-recommendations';
const HISTORY_RESTORE_MS = 300;
const SWIPE_LIMIT_PX = 24;
const INTERACTIVE_SELECTOR = 'a,button,input,select,textarea,summary,label,[role="button"],[role="link"],slideshow-control,slideshow-arrows,slideshow-controls';
let scheduled = false;
let observedAnnouncement;
let headerSection;
let previousInert = false;
let productHero;
let announcementHeight = 0;
let revealed = false;
let pointerOrigin = null;
let cartDrawer;
let removeLookPopstate;

function setStyle(style, property, value) {
  if (style.getPropertyValue(property) !== value) style.setProperty(property, value);
}
function setClass(name, enabled) {
  const classes = document.documentElement.classList;
  if (classes.contains(name) !== enabled) classes.toggle(name, enabled);
}

function matchNavigationType() {
  const header = document.querySelector('#header-component');
  if (!header) return;
  for (const [scope, link, prefix] of [
    [header, header.querySelector('header-menu .menu-list__link'), 'desktop'],
  ]) {
    if (!scope || !link) continue;
    const computed = getComputedStyle(link);
    setStyle(scope.style, `--wc-nav-${prefix}-font-size`, computed.fontSize);
    setStyle(scope.style, `--wc-nav-${prefix}-font-family`, computed.fontFamily);
  }
}
function update() {
  scheduled = false;
  const active = mobileViewport.matches && Boolean(productHero);
  setClass('wc-mobile-product-ready', active);
  // The native observer must not interpret our transform as a sticky-state change.
  document.querySelector('#header-component')?.setMobileProductMode?.(active);
  const drawerOpen = Boolean(headerSection?.querySelector('details[open]'));
  const focusInsideHeader = Boolean(headerSection?.contains(document.activeElement));
  if (!active) revealed = false;
  else if (drawerOpen || focusInsideHeader) revealed = true;
  else if (window.scrollY >= Math.max(32, announcementHeight)) revealed = true;
  else if (window.scrollY <= 4) revealed = false;
  // Keep the prior state between thresholds so touch bounce cannot restart the transition.
  setClass('wc-mobile-product-scrolled', revealed);
  if (headerSection) {
    const inert = active && !revealed ? true : previousInert;
    if (headerSection.inert !== inert) headerSection.inert = inert;
  }
}
function measureAnnouncement() {
  // This measurement never runs from the scroll handler. Changing viewport offsets
  // while scrolling forces layout and makes the native header observers oscillate.
  announcementHeight = Math.round(observedAnnouncement?.getBoundingClientRect().height || 0);
  setStyle(document.documentElement.style, '--wc-mobile-announcement-height', `${announcementHeight}px`);
}
function scheduleUpdate() {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(update);
}
const announcementResize = new ResizeObserver(() => { measureAnnouncement(); scheduleUpdate(); });
function initialize() {
  productHero = document.querySelector('[data-wc-mobile-product-hero]');
  const nextHeaderSection = document.querySelector('.header-section:has(> #header-component)');
  if (headerSection !== nextHeaderSection) {
    if (headerSection) {
      headerSection.inert = previousInert;
      headerSection.querySelector('#header-component')?.setMobileProductMode?.(false);
    }
    headerSection = nextHeaderSection;
    previousInert = headerSection?.inert || false;
  }
  const announcement = document.querySelector('#header-group .announcement-bar');
  if (announcement !== observedAnnouncement) {
    announcementResize.disconnect();
    if (announcement) announcementResize.observe(announcement);
    observedAnnouncement = announcement;
  }
  const recommendations = findLookDestination();
  document.querySelectorAll('[data-wc-complete-the-look]').forEach(link => {
    link.hidden = !recommendations;
    if (recommendations) link.href = `#${recommendations.id}`;
  });
  bindCartDrawerClose();
  matchNavigationType();
  measureAnnouncement();
  update();
}
function eventTarget(event) {
  const target = event?.target;
  if (target?.closest) return target;
  return target?.parentElement || null;
}
function pointerDelta(start, end) {
  if (!start || !end) return 0;
  return Math.hypot(end.clientX - start.clientX, end.clientY - start.clientY);
}
function pointerMovedTooFar(start, end) {
  return pointerDelta(start, end) > SWIPE_LIMIT_PX;
}
function shouldIgnoreMediaTap(target) {
  return !target?.closest || Boolean(target.closest(INTERACTIVE_SELECTOR));
}
function isProductMediaTap(target) {
  if (shouldIgnoreMediaTap(target)) return false;
  return Boolean(target.closest(MEDIA_SELECTOR));
}
function findBuyCluster() {
  const root = productHero?.closest?.('.product-information') || document;
  return root.querySelector(BUY_SELECTOR);
}
function scrollBehavior() {
  return reducedMotion.matches ? 'instant' : 'smooth';
}
function findLookGrid() {
  const grid = document.querySelector(LOOK_GRID_SELECTOR);
  if (!grid?.getClientRects().length) return null;
  return grid;
}
function findLookDestination() {
  return findLookGrid() || document.querySelector(LOOK_HEADING_SELECTOR) || document.querySelector(LOOK_SECTION_SELECTOR);
}
function revealLookDestination(destination) {
  destination.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
  destination.setAttribute('tabindex', '-1');
  destination.focus({ preventScroll: true });
}
function scrollLookIntoView() {
  const destination = findLookGrid();
  if (!destination) return false;
  revealLookDestination(destination);
  return true;
}
function clearLookPopstate() {
  removeLookPopstate?.();
  removeLookPopstate = null;
}
function scrollLookOnNextPopstate() {
  clearLookPopstate();
  const onPopState = () => {
    clearLookPopstate();
    if (!isMobileProductPage()) return;
    scrollLookIntoView();
  };
  removeLookPopstate = () => {
    window.removeEventListener('popstate', onPopState);
  };
  window.addEventListener('popstate', onPopState, { once: true });
}
function holdScrollRestoration() {
  const history = globalThis.history;
  if (!history || !('scrollRestoration' in history)) return () => {};
  const previous = history.scrollRestoration;
  history.scrollRestoration = 'manual';
  return () => {
    history.scrollRestoration = previous || 'auto';
  };
}
function revealLookAfterCartClose() {
  if (!isMobileProductPage() || !scrollLookIntoView()) return;
  const release = holdScrollRestoration();
  scrollLookOnNextPopstate();
  const dropListener = removeLookPopstate;
  const timer = setTimeout(() => {
    if (isMobileProductPage()) scrollLookIntoView();
    clearLookPopstate();
  }, HISTORY_RESTORE_MS);
  removeLookPopstate = () => {
    clearTimeout(timer);
    dropListener?.();
    release();
  };
  requestAnimationFrame(() => requestAnimationFrame(() => {
    if (isMobileProductPage()) scrollLookIntoView();
  }));
}
function handleCartDrawerClose() {
  revealLookAfterCartClose();
}
function bindCartDrawerClose() {
  const drawer = document.querySelector(CART_DRAWER_SELECTOR);
  if (!drawer || drawer === cartDrawer) return;
  cartDrawer?.removeEventListener('dialog:close', handleCartDrawerClose);
  cartDrawer = drawer;
  cartDrawer.addEventListener('dialog:close', handleCartDrawerClose);
}
function scrollToBuyCluster() {
  const cluster = findBuyCluster();
  if (!cluster) return false;
  cluster.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
  return true;
}
function isMobileProductPage() {
  if (!mobileViewport.matches) return false;
  if (!document.querySelector('[data-wc-mobile-product-hero]')) return false;
  if (!productHero) initialize();
  return Boolean(productHero);
}
function rememberPointer(event) {
  if (!isMobileProductPage()) {
    pointerOrigin = null;
    return;
  }
  pointerOrigin = { clientX: event.clientX, clientY: event.clientY };
}
function handleLookLink(event) {
  const link = eventTarget(event)?.closest('[data-wc-complete-the-look]');
  if (!link || !mobileViewport.matches) return false;
  const destination = document.getElementById(link.hash.slice(1));
  if (!destination) return false;
  event.preventDefault();
  revealLookDestination(destination);
  return true;
}
function handleMediaTap(event) {
  if (!isMobileProductPage()) return false;
  if (pointerMovedTooFar(pointerOrigin, event)) return false;
  if (!isProductMediaTap(eventTarget(event))) return false;
  return scrollToBuyCluster();
}
function handleDocumentClick(event) {
  if (!handleLookLink(event)) handleMediaTap(event);
  pointerOrigin = null;
}
document.addEventListener('pointerdown', rememberPointer, { passive: true });
document.addEventListener('click', handleDocumentClick);
window.addEventListener('scroll', scheduleUpdate, { passive: true });
window.addEventListener('resize', () => { matchNavigationType(); measureAnnouncement(); scheduleUpdate(); }, { passive: true });
window.addEventListener('pageshow', initialize);
window.addEventListener('load', initialize);
mobileViewport.addEventListener('change', initialize);
document.addEventListener('shopify:section:load', initialize);
document.addEventListener('shopify:section:unload', () => requestAnimationFrame(initialize));
document.addEventListener('toggle', scheduleUpdate, true);
document.addEventListener('focusout', scheduleUpdate);
document.fonts?.ready.then(matchNavigationType);
customElements.whenDefined('header-component').then(initialize);
initialize();
